export default {
  perfectMoney: {
    title: "To continue, click on the desired option:",
    buyButton: "Buy",
    sellButton: "Sell",
    notVerified: {
      title: "You are not verified",
      subtitle: "To buy and sell Perfect Money, complete your verification",
      verificationButton: "Complete Verification"
    },
    buyPage: {
      title: 'You are "Buying" {n}.',
      availableBalance: "Withdrawable Balance:",
      payment: "You Pay",
      noResults: "No results found.",
      noData: "No results found.",
      received: "You Receive (approximately)",
      pmLabel: "Perfect Money Address",
      rules: {
        part1:
          "By placing this order, I confirm that I have read and accepted the ",
        linkTitle: "Excoino rules",
        part2: "."
      },
      submitButton: "Continue the {n} Process",
      balanceNotEnough: "Your wallet balance is insufficient.",
      maxReceive: "The maximum amount receivable is {amount}.",
      minReceive: "The minimum amount receivable is {amount}."
    },
    sellPage: {
      title: 'You are "Selling" {n}.',
      payment: "You Pay",
      noResults: "No results found.",
      noData: "No results found.",
      received: "You Receive (approximately)",
      rules: {
        part1:
          "By placing this order, I confirm that I have read and accepted the ",
        linkTitle: "Excoino rules",
        part2: "."
      },
      submitButton: "Continue the {n} Process",
      evCode: "Voucher Code",
      evNumber: "Voucher Number"
    },
    orderProcess: {
      cancelButton: "Cancel Order",
      buy: {
        expireTitle: "Your time to complete this order has expired.",
        payment: "Payment",
        netReceived: "Net Received",
        fee: "Fee:",
        addressTitle: "Address",
        submitButton: "Continue the Purchase Process",
        receivedCodeLabel: "SMS Code",
        resendCodeTitle: "Resend code in {n} seconds",
        resendCodeButton: "Resend Verification Code",
        verifyOtpButton: "Confirm and Finalize",
        successOrder: {
          title: "Your purchase request was successfully registered",
          subtitle:
            "After confirmation by Excoino, your order will be completed.",
          payment: "Payment",
          netReceived: "Net Received",
          transactionNumber: "Transaction Number:",
          fee: "Fee:",
          addressTitle: "Address",
          submitDate: "Registration Date and Time:",
          transactionHistoryHistoryButton: "View Transaction Status",
          dashboardButton: "Go to Dashboard"
        }
      },
      sell: {
        expireTitle: "Your time to complete this order has expired.",
        payment: "Payment",
        netReceived: "Net Received",
        fee: "Fee:",
        submitButton: "Continue the Selling Process",
        perfectMoneyHint:
          "To connect to the Perfect Money payment gateway, use an IP address other than Iran.",
        successOrder: {
          title: "Your purchase request was successfully registered",
          payment: "Payment",
          netReceived: "Net Received",
          transactionNumber: "Transaction Number:",
          fee: "Fee:",
          changeFee: "Conversion Fee:",
          submitDate: "Registration Date and Time:",
          transactionHistoryHistoryButton: "View Transaction Status",
          dashboardButton: "Go to Dashboard"
        }
      }
    },
    reSubmitSell: {
      title: "Unsuccessful Transaction",
      payment: "Payment",
      netReceived: "Net Received",
      transactionNumber: "Transaction Number:",
      paymentPrice: "Payment Amount:",
      submitDate: "Registration Date and Time:",
      transactionHistoryHistoryButton: "View Transaction Status",
      dashboardButton: "Go to Dashboard",
      repeatOrderButton: "Repeat Order"
    }
  }
};
